import React, { useState } from "react";
import ResetPasswordEmailConfirm from "../../../components/updated/authentication/resetPassowordEmailConfirm";
import { useTheme } from "@mui/material/styles";
import ResetPassword from "../../../components/updated/authentication/resetPassowordNewPassword";
import { Navigate, useLocation } from "react-router-dom";

const ResetPass = () => {
  const theme = useTheme();
  const location = useLocation();
  /*
   * `|| ""` destructures to undefined, it does not default. That is how this
   * page crashed: the only legitimate way in is the login screen's "forgot
   * password", which calls sendForgotPasswordOtp and THEN navigates with
   * state: { email }. Open /auth/reset-password directly — or refresh
   * mid-flow, which discards router state — and email is undefined, which
   * obfuscateEmail then splits on.
   */
  const email = location.state && location.state.email;
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  /*
   * Send them back to the start rather than render a form that cannot work.
   * Without an address no OTP was ever sent, so there is nothing to verify
   * and no account to reset — an empty form here would just fail on submit.
   * `replace` so Back does not bounce straight into this same dead end.
   */
  if (!email) return <Navigate to="/auth/login" replace />;

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: theme?.palette?.background.default,
        color: theme?.palette?.text?.primary,
      }}
    >
      {isOtpVerified ? (
        <ResetPassword email={email} />
      ) : (
        <ResetPasswordEmailConfirm
          email={email}
          onOtpVerified={() => setIsOtpVerified(true)}
        />
      )}
    </div>
  );
};

export default ResetPass;
